import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "main-auth content" }
const _hoisted_2 = { class: "main-auth__filter" }

import { ref, onMounted, onBeforeUnmount, computed } from 'vue'
import { watchDebounced } from '@vueuse/core'
import { myTasks } from '@/mocks/MyTasks'

// Components
import TaskSlider from '@/components/TaskSlider'
import Welcome from '@/components/Welcome'

// i18n
import { useI18n } from 'vue-i18n'
import type { StatusType } from '@/components/TaskSlider'

// Store
import { useMainStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'Auth',
  setup(__props) {

const { t } = useI18n()

// Types
const mainStore = useMainStore()

// Data
const options: Array<{value: StatusType, label: string}> = [
  {
    value: 'new',
    label: t('statuses.new'),
  },
  {
    value: 'done',
    label: t('statuses.done'),
  },
  {
    value: 'error',
    label: t('statuses.error'),
  },
  {
    value: 'awaitPayment',
    label: t('statuses.awaitPayment'),
  },
  {
    value: 'awaitReview',
    label: t('statuses.awaitReview'),
  },
]

// Computed
const myTasksQuery = computed(() => {
  return {
    type: 'my',
    status: mainStore.myTasks.status
  }
})
const emptyText = computed<string>(() => {
  return (mainStore.myTasks.status.length) ? t('main.auth.empty.notFound') : t('main.auth.empty.myTasks')
})

// Watch
watchDebounced(
    () => mainStore.myTasks.status,
    async () => {
      mainStore.myTasks.loading = true
      try {
        const result = await mainStore.getTasks(myTasksQuery.value)
        mainStore.myTasks.items = result
      } catch (e: any) {
      } finally {
        mainStore.myTasks.loading = false
      }
    },
    { debounce: 1500, maxWait: 5000, deep: true },
)

onMounted(async () => {
  mainStore.myTasks.loading = true
  mainStore.newTasks.loading = true

  try {
    const [myTasks, newTasks] = await Promise.allSettled([
      mainStore.getTasks(myTasksQuery.value),
      mainStore.getTasks({ type: 'new' }),
    ])
    const result = { myTasks, newTasks }
    if (result.myTasks.status === 'fulfilled') {
      mainStore.myTasks.items = result.myTasks.value
    }
    if (result.newTasks.status === 'fulfilled') {
      mainStore.newTasks.items = result.newTasks.value
    }
  } catch (e: any) {
  } finally {
    mainStore.myTasks.loading = false
    mainStore.newTasks.loading = false
    mainStore.myTasks.init = true
    mainStore.newTasks.init = true
  }
})

onBeforeUnmount(() => {
  mainStore.$reset()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Welcome), { class: "main-auth__welcome" }),
    _createVNode(_unref(TaskSlider), {
      items: _unref(mainStore).myTasks.items,
      "is-loading": _unref(mainStore).myTasks.loading,
      init: _unref(mainStore).myTasks.init,
      title: _ctx.$t('myTasks'),
      emptyText: emptyText.value
    }, {
      filter: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('sortBy')) + ":", 1),
          _createVNode(_component_el_select, {
            modelValue: _unref(mainStore).myTasks.status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(mainStore).myTasks.status) = $event)),
            multiple: "",
            "collapse-tags": "",
            "collapse-tags-tooltip": "",
            clearable: "",
            placeholder: _ctx.$t('choose')
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _: 1
    }, 8, ["items", "is-loading", "init", "title", "emptyText"]),
    _createVNode(_unref(TaskSlider), {
      items: _unref(mainStore).newTasks.items,
      "is-loading": _unref(mainStore).newTasks.loading,
      init: _unref(mainStore).newTasks.init,
      title: _ctx.$t('newTasks'),
      emptyText: _ctx.$t('main.auth.empty.newTasks')
    }, null, 8, ["items", "is-loading", "init", "title", "emptyText"])
  ]))
}
}

})